"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validAssetStatuses = exports.publicPortalDomain = exports.profile = exports.isStudio = exports.isPublicPortal = exports.isPIRAEnabled = exports.isMetricsEnabled = exports.isMarketingSite = exports.isLCSEnabled = exports.featureFlags = exports.featureFlag = exports.entitlements = exports.entitlement = exports.context = exports.REUSE_METRICS_ENABLED = exports.PUBLIC_PORTAL_PIRA_ENABLED = exports.PORTAL_RE_ARCHITECTURE_ENABLED = exports.LOGGED_OUT_PIRA_ENABLED = exports.EXCHANGE_ENTITLEMENT = exports.ASSET_USAGE_AND_ENGAGEMENT_ENTITLEMENT = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reselect = require("reselect");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var context = exports.context = (0, _reselect.createSelector)(function (state) {
  return state.session.context;
}, function (state) {
  return state.session.featureFlags;
}, function ($context, $featureFlags) {
  if ($featureFlags) {
    return _objectSpread(_objectSpread({}, $context), {}, {
      featureFlags: $featureFlags
    });
  }
  return $context;
});
var profile = exports.profile = function profile(state) {
  var _state$session;
  return (_state$session = state.session) === null || _state$session === void 0 ? void 0 : _state$session.profile;
};
var isStudio = exports.isStudio = function isStudio(state) {
  var _state$session$studio;
  return !!((_state$session$studio = state.session.studioMetadata) !== null && _state$session$studio !== void 0 && _state$session$studio.version);
};
var publicPortalDomain = exports.publicPortalDomain = function publicPortalDomain(state) {
  var _state$session2;
  return (_state$session2 = state.session) === null || _state$session2 === void 0 ? void 0 : _state$session2.publicPortalDomain;
};
var isPublicPortal = exports.isPublicPortal = function isPublicPortal(state) {
  return !!publicPortalDomain(state);
};
var PORTAL_RE_ARCHITECTURE_ENABLED = exports.PORTAL_RE_ARCHITECTURE_ENABLED = 'portal-re-architecture-enabled';
var PUBLIC_PORTAL_PIRA_ENABLED = exports.PUBLIC_PORTAL_PIRA_ENABLED = 'public-portal-pira-enabled';
var LOGGED_OUT_PIRA_ENABLED = exports.LOGGED_OUT_PIRA_ENABLED = 'logged-out-pira-enabled';
var REUSE_METRICS_ENABLED = exports.REUSE_METRICS_ENABLED = 'reuse-metrics-enabled';
var EXCHANGE_ENTITLEMENT = exports.EXCHANGE_ENTITLEMENT = 'exchange2';
var ASSET_USAGE_AND_ENGAGEMENT_ENTITLEMENT = exports.ASSET_USAGE_AND_ENGAGEMENT_ENTITLEMENT = 'assetUsageAndEngagement';
var isMarketingSite = exports.isMarketingSite = function isMarketingSite(state) {
  return state.session.isMarketingSite;
};
var entitlements = exports.entitlements = (0, _reselect.createSelector)(profile, function ($profile) {
  var _$profile$organizatio;
  return $profile === null || $profile === void 0 || (_$profile$organizatio = $profile.organization) === null || _$profile$organizatio === void 0 ? void 0 : _$profile$organizatio.entitlements;
});
var entitlement = exports.entitlement = function entitlement(state, entitlementKey, subEntitlementKey) {
  var $entitlements = entitlements(state);
  if (!$entitlements) {
    return false;
  }
  if (subEntitlementKey) {
    var _$entitlements$entitl, _subEntitlement$enabl;
    var subEntitlement = (_$entitlements$entitl = $entitlements[entitlementKey]) === null || _$entitlements$entitl === void 0 ? void 0 : _$entitlements$entitl[subEntitlementKey];
    return typeof subEntitlement === 'boolean' ? subEntitlement : (_subEntitlement$enabl = subEntitlement === null || subEntitlement === void 0 ? void 0 : subEntitlement.enabled) !== null && _subEntitlement$enabl !== void 0 ? _subEntitlement$enabl : false;
  }
  var $entitlement = $entitlements[entitlementKey];
  if (typeof $entitlement === 'boolean') {
    return $entitlement;
  }
  if ('enabled' in $entitlement && typeof $entitlement.enabled === 'boolean') {
    return $entitlement.enabled;
  }
  return false;
};
var featureFlags = exports.featureFlags = function featureFlags(state) {
  var _state$session$featur, _state$session3;
  return (_state$session$featur = (_state$session3 = state.session) === null || _state$session3 === void 0 ? void 0 : _state$session3.featureFlags) !== null && _state$session$featur !== void 0 ? _state$session$featur : {};
};
var featureFlag = exports.featureFlag = function featureFlag(state, featureFlagKey) {
  return featureFlags(state)[featureFlagKey];
};
var isMetricsEnabled = exports.isMetricsEnabled = function isMetricsEnabled(state) {
  return featureFlag(state, REUSE_METRICS_ENABLED) && entitlement(state, EXCHANGE_ENTITLEMENT, ASSET_USAGE_AND_ENGAGEMENT_ENTITLEMENT);
};
var isPIRAEnabled = exports.isPIRAEnabled = function isPIRAEnabled(state) {
  var _ref;
  return (!isPublicPortal(state) || featureFlag(state, PUBLIC_PORTAL_PIRA_ENABLED) === true) && !isStudio(state) && !isMarketingSite(state) && ((_ref = !!profile(state) || featureFlag(state, LOGGED_OUT_PIRA_ENABLED)) !== null && _ref !== void 0 ? _ref : false) && featureFlag(state, PORTAL_RE_ARCHITECTURE_ENABLED) === true;
};
var isLCSEnabled = exports.isLCSEnabled = (0, _reselect.createSelector)(isStudio, isPublicPortal, featureFlags, function ($isStudio, $isPublicPortal, $featureFlags) {
  var isPortalRearchitectureEnabled = $featureFlags[PORTAL_RE_ARCHITECTURE_ENABLED];
  return !$isStudio && !$isPublicPortal && isPortalRearchitectureEnabled;
});
var validAssetStatuses = exports.validAssetStatuses = (0, _reselect.createSelector)(isLCSEnabled, function ($isLCSEnabled) {
  if ($isLCSEnabled) {
    return ['development', 'published', 'deprecated'];
  }
  return ['published', 'deprecated'];
});
//# sourceMappingURL=selectors.js.map